const SERVER_BASE_URL = 'https://backend-crop2x.pythonanywhere.com/';
// const SERVER_BASE_URL = "http://127.0.0.1:5000";
const PDF_SERVER_URL =
  "https://crop-monitoring-pdf-generation-backend.vercel.app";
// const PDF_SERVER_URL = 'http://localhost:5000';
const Predicted_yield = "https://prediction-crop2x.pythonanywhere.com";
export const urls = {
  base: `${SERVER_BASE_URL}/`,
  start_batch: `${SERVER_BASE_URL}/start_batch`,
  delete_field: `${SERVER_BASE_URL}/delete_field`,
  get_results: `${SERVER_BASE_URL}/get_results`,
  deleteUser: `${SERVER_BASE_URL}/users`,
  indices_value: `${SERVER_BASE_URL}/indices_value`,
  get_fieldnames: `${SERVER_BASE_URL}/get_fieldnames`,
  api_analyze_polygon: `${SERVER_BASE_URL}/api/analyze_polygon`,
  delete: `${SERVER_BASE_URL}/delete`,
  records: `${SERVER_BASE_URL}/records`,
  login: `${SERVER_BASE_URL}/login`,
  pDF: `${PDF_SERVER_URL}/generate-pdf`,
  yield: `${Predicted_yield}/predict_yield`,
  loginAdmin: `${SERVER_BASE_URL}/loginAdmin`,
  updatePlan: `${SERVER_BASE_URL}/updatePlan`,
  getUsers: `${SERVER_BASE_URL}/getUsers`,
  getTelUsers: `${SERVER_BASE_URL}/getTelUsers`,
  getPricing: `${SERVER_BASE_URL}/get-pricing`,
  getCloud: `${SERVER_BASE_URL}/getCloud`,
  updateCloud: `${SERVER_BASE_URL}/updateCloud`,
  updatePricing: `${SERVER_BASE_URL}/update-pricing`,
  delete_user_data: `${SERVER_BASE_URL}/delete_user_data`,
  updatePixels: `${SERVER_BASE_URL}/updatePixels`,
  getPixels: `${SERVER_BASE_URL}/getPixels`,
  saveWeather: `${SERVER_BASE_URL}/save-weather`,
  updatePassword: `${SERVER_BASE_URL}/update-password`,
  getUid: `${SERVER_BASE_URL}/get-uid`,
  saveFieldImage: `${SERVER_BASE_URL}/save-field-image`,
  baseAreaImage: `${SERVER_BASE_URL}/base-area-image`,
  get_device_id: `${Predicted_yield}/get_device_id`,
  get_heatmap_data: `${Predicted_yield}/get_heatmap_data`,
  devicesDates: `${Predicted_yield}/devices`,
  process_csv: `${Predicted_yield}/process_csv`,
  process_data: `${Predicted_yield}/process_data`,
  search_devices: `${Predicted_yield}/search_devices`,
  delete_device: `${Predicted_yield}/delete_device`,
  assign_device: `${Predicted_yield}/assign_device`,
  pages: `${SERVER_BASE_URL}/pages`,
  pages_toggle: `${SERVER_BASE_URL}/pages/toggle`,
  map_data: `${SERVER_BASE_URL}/usage-locations`,
  weather_process: `${SERVER_BASE_URL}/weather/process`,
  weather_notifications: `${SERVER_BASE_URL}/weather/notifications`,
  weather_notifications_read: `${SERVER_BASE_URL}/weather/notifications/read`,
  weather_notifications_read_all: `${SERVER_BASE_URL}/weather/notifications/read-all`,
};
